import { generalI18n } from "../global/general-i18n";
import { i18n } from './I18n';
export const DEFAULT_TZ = 'Europe/Vienna';
export function twoDigit(value) {
  if (value == 0 || value < 10) {
    return '0' + value;
  }
  else {
    return value.toString();
  }
}
export function formatTime(date) {
  return twoDigit(date.getHours()) + ':' + twoDigit(date.getMinutes());
}
export function formatTicketshopDate(date) {
  // 2018-06-7T19:00
  return date.getFullYear() + '-' + twoDigit(date.getMonth() + 1) + '-' + twoDigit(date.getDate()) + 'T' + formatTime(date);
}
export function formatIsoDate(date) {
  if (!date) {
    return '';
  }
  // 30.12.2018
  return date.getFullYear() + '-' + twoDigit(date.getMonth() + 1) + '-' + twoDigit(date.getDate());
}
export function parseIsoDate(date) {
  if (!date) {
    return null;
  }
  if (date instanceof Date) {
    return date;
  }
  const parsed = new Date(date);
  if (isNaN(parsed.valueOf())) {
    return null;
  }
  return parsed;
}
export function parseTime(input) {
  var _a;
  try {
    // Allow "[H]HMM" or "[H]H:[M]M" as format
    const parts = (_a = input.match(/^(\d{1,2})(\d{2})$/)) !== null && _a !== void 0 ? _a : input.match(/^(\d{1,2}):(\d{1,2})$/);
    if (!parts) {
      return null;
    }
    const hour = parseInt(parts[1]);
    const minute = parseInt(parts[2]);
    if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
      return null;
    }
    const myDate = new Date();
    myDate.setHours(hour);
    myDate.setMinutes(minute);
    return myDate;
  }
  catch (err) {
    return null;
  }
}
export function formatDayOfWeek(date) {
  return i18n.get(days[date.getDay()]);
}
export function formatDate(date, includeYear = true) {
  return formatDayOfWeek(date)
    + ', '
    + twoDigit(date.getDate())
    + '. '
    + i18n.get(months[date.getMonth()] + '-short', months[date.getMonth()])
    + (includeYear ? ' ' + date.getFullYear() : '');
}
export function formatLocalDate(date, locale, timezone = DEFAULT_TZ) {
  return (date === null || date === void 0 ? void 0 : date.toLocaleDateString(locale || i18n.getLang() || 'de', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: timezone,
  })) || '';
}
export function formatDateShort(date) {
  try {
    return twoDigit(date.getDate()) + '.' + twoDigit(date.getMonth() + 1) + '.' + date.getFullYear();
  }
  catch (e) {
    return '';
  }
}
export const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
export const monthsDe = ['JÄN', 'FEB', 'MÄR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'];
export const monthsEn = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
export const monthsIt = ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'];
export const monthsShort = months
  .map(month => generalI18n.find(strings => strings.key === `${month}-short`))
  .map(strings => Object.values(strings).map((value) => value.toLocaleUpperCase()));
export function getLocalizedMonthIndex(data) {
  const needle = data.toLocaleUpperCase();
  return monthsShort.findIndex(strings => strings.includes(needle));
}
export function parseDate(input) {
  try {
    const partsNumeric = input.match(/^(0?[1-9]|[12]\d|3[0-1])[./]?(0?[1-9]|1[0-2])[./]?((19|2\d)?\d{2})$/);
    if (partsNumeric) {
      const day = parseInt(partsNumeric[1]);
      const month = parseInt(partsNumeric[2]);
      const year = parseInt(partsNumeric[3]);
      return new Date(year < 100 ? 2000 + year : year, month - 1, day, 0, 0, 0, 0);
    }
    const partsIso = input.match(/^((19|2\d)?\d{2})-?(0?[1-9]|1[0-2])-?(0?[1-9]|[12]\d|3[0-1])$/);
    if (partsIso) {
      const year = parseInt(partsIso[1]);
      const month = parseInt(partsIso[3]);
      const day = parseInt(partsIso[4]);
      return new Date(year < 100 ? 2000 + year : year, month - 1, day, 0, 0, 0, 0);
    }
    const parts = input.match(/(\w+)/g);
    if (parts.length == 3) {
      let day = parseInt(parts[0]);
      let month = parseInt(parts[1]);
      let year = parseInt(parts[2]);
      if (isNaN(month)) {
        month = getLocalizedMonthIndex(parts[1]);
      }
      else {
        month -= 1;
      }
      if (parts[2].length == 2)
        year = parseInt('20' + parts[2]); // This doesn't work after the year 2099
      return new Date(year, month, day);
    }
    else if (parts.length == 4) {
      let day = parseInt(parts[1]);
      let month = parseInt(parts[2]);
      let year = parseInt(parts[3]);
      if (isNaN(month)) {
        month = getLocalizedMonthIndex(parts[2]);
      }
      else {
        month -= 1;
      }
      if (parts[3].length == 2)
        year = parseInt('20' + parts[3]); // This doesn't work after the year 2099
      return new Date(year, month, day);
    }
    else {
      return null;
    }
  }
  catch (err) {
    return null;
  }
}
let holidaysStatic = [
  {
    'day': 1,
    'month': 0
  },
  {
    'day': 6,
    'month': 0
  },
  {
    'day': 1,
    'month': 4
  },
  {
    'day': 6,
    'month': 0
  },
  {
    'day': 15,
    'month': 7
  },
  {
    'day': 26,
    'month': 9
  },
  {
    'day': 1,
    'month': 10
  },
  {
    'day': 8,
    'month': 11
  },
  {
    'day': 25,
    'month': 11
  },
  {
    'day': 26,
    'month': 11
  },
];
let holidaysEaster = {
  '2019': new Date('2019-04-21'),
  '2020': new Date('2020-04-12'),
  '2021': new Date('2021-04-04'),
  '2022': new Date('2022-04-17'),
  '2023': new Date('2023-04-09'),
  '2024': new Date('2024-03-31'),
  '2025': new Date('2025-04-20'),
  '2026': new Date('2026-04-05'),
  '2027': new Date('2027-03-28'),
  '2028': new Date('2028-04-16'),
  '2029': new Date('2029-04-01'),
  '2030': new Date('2030-04-21'),
  '2031': new Date('2031-04-13'),
};
export function addDaysToDate(days, date) {
  let newDate = date ? new Date(date) : new Date();
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}
export function addWorkingDays(date, days, respectAustrianHolidays = true) {
  const isAdding = (days > 0);
  if (!isAdding) {
    days = Math.abs(days);
  }
  while (days > 0) {
    if (!isAdding) {
      date.setDate(date.getDate() - 1);
    }
    else {
      date.setDate(date.getDate() + 1);
    }
    if (date.getDay() == 0 || date.getDay() == 6 || (respectAustrianHolidays && isAustrianHoliday(date)))
      continue;
    days--;
  }
  return date;
}
export function isAustrianHoliday(date) {
  let isHoliday = holidaysStatic.some(function (holiday) {
    return (holiday.day === date.getDate() && holiday.month === date.getMonth());
  });
  // Return if holiday is found, no need to check for days based on easter
  if (isHoliday)
    return isHoliday;
  // Easter
  let thisYear = new Date().getFullYear();
  let thisEaster = holidaysEaster[thisYear];
  if (thisEaster.getDate() === date.getDate() && thisEaster.getMonth() === date.getMonth()) {
    return true;
  }
  // Easter Monday
  let easterMonday = addDaysToDate(1, thisEaster);
  if (easterMonday.getDate() === date.getDate() && easterMonday.getMonth() === date.getMonth()) {
    return true;
  }
  // Christi Himmelfahrt
  let ascension = addDaysToDate(39, thisEaster);
  if (ascension.getDate() === date.getDate() && ascension.getMonth() === date.getMonth()) {
    return true;
  }
  // Pfingsten
  let pentecostSunday = addDaysToDate(49, thisEaster);
  if (pentecostSunday.getDate() === date.getDate() && pentecostSunday.getMonth() === date.getMonth()) {
    return true;
  }
  let pentecostMonday = addDaysToDate(50, thisEaster);
  if (pentecostMonday.getDate() === date.getDate() && pentecostMonday.getMonth() === date.getMonth()) {
    return true;
  }
  // Fronleichnam
  let corpusChristi = addDaysToDate(60, thisEaster);
  if (corpusChristi.getDate() === date.getDate() && corpusChristi.getMonth() === date.getMonth()) {
    return true;
  }
  return false;
}
export function isLastDayOfMonth(date) {
  let checkDate = new Date(date.getTime());
  checkDate.setDate(checkDate.getDate() + 1);
  return checkDate.getDate() === 1;
}
export function isSameDate(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
//# sourceMappingURL=date.js.map
